<template>
  <v-container
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      v-if="!$apollo.loading"
      wrap
    >
      <v-flex
        v-for="(bot) in rankings"
        :key="bot.id"
        xs12
        md4
      >
        <v-card
          class="bot-card"
        >
          <v-flex
            class="cover"
            :style="{ backgroundColor: bot.project.bgcolor}"
            xs12
            md12
          >
            <v-avatar
              v-if="bot.project.logo !== null"
              :tile="false"
              class="avatar"
              :size="110"
            >
              <v-img
                :src="bot.project.logo"
                :lazy-src="bot.project.logo"
                max-height="110"
                contain
              />
            </v-avatar>
            <v-avatar
              v-else
              class="avatar"
              style="pointer: cursor;"
              :tile="false"
              :size="110"
              color="#eceff1"
            >
              <strong
                class="avatar-invert"
                style="font-size:30px;"
              >{{ bot.project.ticker | uppercase | substring(0,2) }}</strong>
            </v-avatar>
          </v-flex>

          <v-flex
            justify-self-center
            text-center
            class="name"
          >
            <h4>{{ bot.project.name }}</h4>
           
            <p style="margin-bottom:0;">
              Bitmex
              <v-tooltip
                v-if="bot.project.type == 'trading.copy'"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    style="margin: -3px 00px 0px; font-size:18px;"
                    v-on="on"
                  >
                    mdi-alpha-c-circle-outline
                  </v-icon>
                </template>
                {{ $t('rankings.botSupportCopy') }}
              </v-tooltip>
            </p>
          </v-flex>
          <v-divider />
          <v-layout
            class="data"
          >
            <v-flex
              xs4
              pl-10
            >
              <span>{{ $t('globals.roi') }}</span>
              <p :class="colorPnL(bot.roi)">
                {{ bot.roi }}%
              </p>
              <span>{{ $t('globals.minDeposit') }}</span>
              <p>{{ bot.project.mindeposit }}</p> 
            </v-flex>
            <v-flex
              xs4
              pl-5
            >
              <span>{{ $t('globals.aum') }}</span>
              <p class="text-primary">
                {{ "BTC" | renderSymbol }} 
                {{ bot.aum }}
              </p>
              <span>{{ $t('globals.investors') }}</span>
              <p>
                {{ bot.connected_investor_accounts }}
              </p>
            </v-flex>
            <v-flex
              xs4
              pr-5
            >
              <span>{{ $t('bots.managementFee') }}</span>
              <p>{{ bot.project.management_fee + bot.project.referral_fee + 5 }}%</p>
              <span>{{ $t('rankings.ownAssetsSmall') }}</span>
              <p>
                {{ "BTC" | renderSymbol }} 
                {{ bot.project.own_assets }}
              </p>
            </v-flex>
          </v-layout>
          <pnl-small-chart :ranking-id="bot.id" />
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="primary"
              @click="$router.push(`/ranking/${bot.id}`)"
            >
              {{ $t('rankings.botsMore') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const RANKINGS_QUERY = require("@/graphql/queries/Rankings.gql");
import PnlSmallChart from "@/views/Rankings/partial/PnLSmallChart.vue";

export default {
  name: "RankingList",
  components: {
    PnlSmallChart
  },
  data() {
    return {
      rankings: [],
      loading: false
    };
  },
  mounted() {
    if (
      this.$route.params.id !== undefined &&
      this.$route.params.id.length === 10
    ) {
      this.$cookie.set("sp", this.$route.params.id, { expires: "1M" });
    }
  },
  methods: {},
  apollo: {
    rankings: {
      query: RANKINGS_QUERY,
      variables: {
        filter: "BOT"
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
